import { css } from 'emotion';
import React from 'react';

const generatedText = css`
  word-break: break-word;
  p {
    margin-top: 0;
    margin-bottom: 0;
  }
`;

export const Text = ({ text, configs }: any) => {
  return (
    <div
      dangerouslySetInnerHTML={{ __html: text }}
      className={generatedText}
      style={{
        borderBottomWidth: `${configs.borderBottomWidth}mm`,
        borderLeftWidth: `${configs.borderLeftWidth}mm`,
        borderRightWidth: `${configs.borderRightWidth}mm`,
        borderTopWidth: `${configs.borderTopWidth}mm`,
        color: configs.color,
        fontFamily: configs.fontFamily,
        fontSize: `${configs.fontSize}mm`,
        height: `${configs.height}mm`,
        left: `${configs.left}mm`,
        lineHeight: `${configs.lineHeight}mm`,
        position: 'absolute',
        top: `${configs.top}mm`,
        transform: `rotateZ(${configs.rotation}deg)`,
        width: `${configs.width}mm`,
        zIndex: 5,
        userSelect: 'none',
        whiteSpace: 'initial',
      }}
    />
  );
};
